import React, { Component } from "react";
import { Menu } from "antd";

const SubMenu = Menu.SubMenu;

class SideNav extends Component {
    constructor(props) {
        super(props);
        let current = 'degree';
        if (props.selectKey) {
            current = props.selectKey;
        }
        this.state = {
            current,
        };
    }

    handleClick = e => {
        this.setState({ current: e.key });
    }

    render() {
        const { curRole, showStaffScore } = sessionStorage;
        const isBO = curRole == 'BO';
        const isCTA = curRole == 'CTA';
        const isVP = curRole == 'VP';
        const isFIN = curRole == 'FIN';
        const isHRRC = curRole == 'HRRC';
        return (
            <aside className="sidebar">
                <Menu
                    onClick={this.handleClick}
                    defaultOpenKeys={['sub1']}
                    selectedKeys={[this.state.current]}
                    mode="inline"
                >
                    <SubMenu key="sub1" title={<span><i className="icon iconfont">&#xe600;</i><span>医院档案</span></span>}>
                        <Menu.Item key="detail">
                            <a href="#/hospital/detail">医院信息</a>
                        </Menu.Item>
                        <Menu.Item key="departmentDetail">
                            <a href="#/hospital/departmentDetail">医院科室信息</a>
                        </Menu.Item>
                        <Menu.Item key="doctor">
                            <a href="#/hospital/doctor">医生信息</a>
                        </Menu.Item>
                        <Menu.Item key="filingInfo">
                            <a href="#/hospital/filingInfo">医院机构备案信息</a>
                        </Menu.Item>
                        {
                            !isHRRC && 
                        <Menu.Item key="ssu">
                            <a href="#/hospital/ssu">SSU通讯录</a>
                        </Menu.Item>
                        }
                        
                        {
                            (isBO || isCTA) &&
                            <Menu.Item key="staffing">
                                <a href="#/hospital/staffing">SSU人员安排</a>
                            </Menu.Item>
                        }
                        {
                            (showStaffScore == 'true') &&
                            <Menu.Item key="staffScore">
                                <a href="#/hospital/staffScore">SSU人员评分</a>
                            </Menu.Item>
                        }
                    </SubMenu>
                </Menu>
            </aside>
        );
    }
}

export default SideNav;



// WEBPACK FOOTER //
// ./src/components/hospital/SideNav.js